import styled, { css } from "styled-components";
import { CoreLink } from "@boi/components-core";
import { parseSizeToken, useDesignTokens } from "@boi/react-design-tokens";

import { LinkBase } from "../LinkBase";
import { Typography } from "../Typography";

export const Wrapper = styled(LinkBase)``;

export const Container = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { link } = tokens;

    return [
      css`
        display: inline-flex;
        gap: ${link.withIcon.gap};
      `,
    ];
  }}
`;

type TextProps = {
  $isUnderlined: boolean;
  $isDashed: boolean;
};

export const Text = styled(Typography)<TextProps>`
  ${({ $isUnderlined, $isDashed }) => {
    const { tokens } = useDesignTokens();
    const { link } = tokens;

    return [
      css`
        background: ${link.backgroundColor.base};

        text-decoration-thickness: ${link.decoration.thickness.base};
        text-underline-offset: ${link.decoration.offset};

        ${Container}:hover && {
          text-decoration-line: ${link.decoration.line.base};
          text-decoration-thickness: ${link.decoration.thickness.hover};
        }

        ${Container}:active && {
          background: ${link.backgroundColor.active};
          text-decoration-line: ${link.decoration.line.base};
          text-decoration-thickness: ${link.decoration.thickness.active};
        }

        ${Wrapper}:focus-visible && {
          text-decoration-line: ${link.decoration.line.focus};
        }
      `,
      $isUnderlined &&
        css`
          text-decoration-line: ${link.decoration.line.base};
          text-decoration-style: ${link.decoration.style.solid};
        `,
      $isUnderlined &&
        $isDashed &&
        css`
          text-decoration-style: ${link.decoration.style.dashed};
        `,
    ];
  }}
`;

type IconWrapperProps = {
  $variant: CoreLink.Variant;
};

export const IconWrapper = styled.div<IconWrapperProps>`
  ${({ $variant }) => {
    const { tokens } = useDesignTokens();
    const { link } = tokens;

    const size = parseSizeToken(link.withIcon.size[$variant]);

    return css`
      flex-shrink: 0;

      svg {
        display: block;
        width: ${size};
        height: ${size};
      }
    `;
  }}
`;
